import { GovFlex } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button, Icon } from '@gov-nx/ui/web';

export const ActionsBinned = () => {
	const { code, documentRestore, deletePermanentConfirm, myFilesSelection } =
		useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<GovFlex gap="s">
			<Button
				aria-label={tsn('akce.obnovit')}
				color="primary"
				type="solid"
				size="s"
				isExpandedMobile
				isLoading={documentRestore.isRestoring}
				onClick={() =>
					documentRestore.restoreDocuments(
						myFilesSelection.selected.map((document) => document.documentId)
					)
				}
				iconStart={
					<Icon
						type="templates"
						name="arrow-clockwise"
					/>
				}>
				{tsn('akce.obnovit', { count: myFilesSelection.selected.length })}
			</Button>
			<Button
				aria-label={tsn('akce.trvale-odstranit')}
				color="error"
				type="outlined"
				size="s"
				isExpandedMobile
				onClick={deletePermanentConfirm.setTrue}
				iconStart={
					<Icon
						type="components"
						name="x-lg"
					/>
				}>
				{tsn('akce.trvale-odstranit', {
					count: myFilesSelection.selected.length,
				})}
			</Button>
		</GovFlex>
	);
};
